import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { DefaultPlan } from "@modules/defaultPlans/types";
import { DefaultPlanFormValues } from "@modules/defaultPlans/validations";
import { editDefaultPlanService } from "./service";
import { UseEditDefaultPlanMutationOptions } from "./types";

export function useEditDefaultPlanMutation(
  options?: UseEditDefaultPlanMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<DefaultPlan, ApiError, { id: string; data: DefaultPlanFormValues }>({
    mutationFn: ({ id, data }) => editDefaultPlanService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("default_plan_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
